import { Iata } from '@reward-platform/platform-config'

/**
 * Chatbot is disabled for the Iberia (IB) market site only.
 * UK and other markets keep the existing chatbot experience.
 */
export const isChatbotEnabledForOpCo = (opCo: Iata): boolean => opCo !== 'IB'
